export const type = {
	bug: 'Bug',
	idea: 'Idea',
	other: 'Other feedback',
};
